import React from 'react';
import ComparisonTableCell from 'src/content/applications/quote/updateQuote/ComparisonTableCell';
import { formatValueForDisplay } from 'src/helper/actualComparison';

/** Same revision interaction as Quote; only document wording/formatting differs. */
export default function ActualsComparisonTableCell(props: React.ComponentProps<typeof ComparisonTableCell>) {
  return <ComparisonTableCell {...props} acceptedLabel="Accepted for Actuals"
    allowDecisionChange={props.allowDecisionChange ?? true}
    formatDisplayValue={props.formatDisplayValue ?? (value => formatValueForDisplay(value, props.field))} />;
}
